import { useCallback, useMemo, useState } from 'react';

import * as columnDefs from '../../../../../components/AGGrid/config/columns-def';
import {filterCriteria} from "../../../../../utils/filterCriteria";
import {getColumnType} from "../../../../../utils/columType";

export function useProductsGridUtils({
                                         datastageApi,
                                         filterForm,
                                         defaultFilterRange,
                                         updateProducts,
                                         isLegalUser,
                                         isLegalAdmin,
                                         handlers
                                     }) {
    const [sortedColId, setSortedColId] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const setSort = useCallback(
        async (colId, direction) => {
            setSortedColId(colId);
            setSortDirection(direction);
            handlers.setLoadingTrue();
            try {
                const data = await datastageApi.products(
                    filterCriteria(filterForm, '', 'products'),
                    defaultFilterRange,
                    [colId, direction.toUpperCase()]
                );
                
                console.log(data.pageable.pageNumber)
                updateProducts({
                    products: data?.content,
                    totalPages: data?.totalPages,
                    totalItems: data?.totalElements,
                    currentPage: data?.pageable?.pageNumber,
                    productSort: [colId, direction.toUpperCase()]
                });
            } catch (error) {
                console.error('Error sorting products:', error);
            } finally {
                handlers.setLoadingFalse();
            }
        },
        [filterForm, defaultFilterRange, updateProducts, handlers]
    );

    const baseColumns = columnDefs['products'](
        ...handlers.columnHandlers
    )[getColumnType('products', isLegalUser, isLegalAdmin)];

    const columns = useMemo(() => (
        baseColumns.map(col => ({
            ...col,
            headerComponentParams: {
                ...col.headerComponentParams,
                setSort,
                sortedColId,
                sortDirection,
            }
        }))
    ), [setSort, sortedColId, sortDirection, baseColumns]);

    return { setSort, columns };
}